import { createAction } from '@reduxjs/toolkit';

/**
 * Shared action dispatched when the user switches company.
 * 
 * All company-specific slices listen to this in their extraReducers
 * to reset state, avoiding the need for multiple individual dispatches.
 * 
 * Payload contains the new company context ID and optional market ID.
 */
export const companyChanged = createAction<{ contextId: string; marketId?: number }>('company/changed');
